import { useDispatch } from "react-redux";
import { CreateProductBody, setPopulateNewProduct } from "../../features/product/productSlice";
import { showToast } from "../../toastify/Toast";
import { Product } from "../../types/product";
import { setTypeModal, setTypeOfShowModalType } from "../../features/modal/modalSlice";

export default function useProductAction() {

    const dispatch = useDispatch()

    const handleSelectUpdateProduct = (product: Product) => {
        
        if (!product.typeInfo) {
            return showToast('Product type is missing', 'error');
        }
        if ( product.isAvailable === undefined || product.isOutOfStock === undefined ) {
            return showToast("Invalid product data", "error");
        }
        const selectedProduct: CreateProductBody = {
            category: {
                id: product.categoryInfo.categoryId,
                label: product.categoryInfo.categoryName
            },
            productName: product.productName ?? '',
            description: product.description ?? '',
            price: product.price,
            size: {
                id: product.sizeInfo.sizeId,
                label: product.sizeInfo.size
            },
            image: product.image ?? '',
            type: {
                id: product.typeInfo.typeId,
                label: product.typeInfo.typeName
            },
            addOns: product.addons ?? [],
            isAvailable: product.isAvailable,
            isOutOfStock: product.isOutOfStock,
            productID: product.productID
        }
        dispatch(setTypeModal('updateProduct'));
        dispatch(setPopulateNewProduct(selectedProduct));
        dispatch(setTypeOfShowModalType('productModal'))
    }

    return {
        handleSelectUpdateProduct
    }
}